import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { staticDataState } from "./staticDataTypes";
import { string } from "yup";

const initialState: staticDataState = {
  userRoles: [],
  agentTypes: [],
  countryCode: [],
  stateList: [],
  orderTypes: [],
  reportTypeStatic: [],
  parentUserId: "",
  thirdPartyApiName: [],
  finalMileIntegration: [],
  auditListModule: [],
  version: ""
};

const staticDataSlice = createSlice({
  name: "staticData",
  initialState,
  reducers: {
    setUserRoles(state, action: PayloadAction<any>) {
      const roles = action.payload;
      state.userRoles = roles;
    },
    setAgentTypes(state, action: PayloadAction<any>) {
      const roles = action.payload;
      state.agentTypes = roles;
    },
    setCountryCode(state, action: PayloadAction<any>) {
      const roles = action.payload;
      state.countryCode = roles;
    },
    setOrderType(state, action: PayloadAction<any>) {
      const roles = action.payload;
      state.orderTypes = roles;
    },
    setReportTypeStatic(state, action: PayloadAction<any>) {
      const roles = action.payload;
      state.reportTypeStatic = roles;
    },
    setParentUserId(state, action: PayloadAction<any>) {
      const roles = action.payload;
      state.parentUserId = roles;
    },
    setThirdPartyApiDropDown(state, action: PayloadAction<any>) {
      const roles = action.payload;
      state.thirdPartyApiName = roles;
    },
    setFinalMileIntegration(state, action: PayloadAction<any>) {
      const roles = action.payload;
      state.finalMileIntegration = roles;
    },
    setStateList(state, action: PayloadAction<any>) {
      state.stateList = action.payload;
    },
    setAuditListModule(state, action: PayloadAction<any>) {
      state.auditListModule = action.payload;
    },
    setVersion(state, action: PayloadAction<any>) {
      state.version = action.payload;
    }
  },
});

export const { setUserRoles, setAgentTypes, setCountryCode, setOrderType, setReportTypeStatic, setParentUserId, setThirdPartyApiDropDown, setFinalMileIntegration, setStateList, setAuditListModule, setVersion } =
  staticDataSlice.actions;

export default staticDataSlice.reducer;
